import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { rotaAnalise } from '../utils/rotas';
import './AnalyserImovelButton.css';
export default function AnalyserImovelButton({ id }) {
  const location = useLocation(), navigate = useNavigate();
  const imovelId = Number(id);
  if (!Number.isSafeInteger(imovelId) || imovelId <= 0) return null;
  return <button type="button" className="lc-analyser-imovel" title="Investigação aprofundada"
    aria-label={`Leilancer Analyser — investigar LC-${imovelId}`}
    onClick={e => {
      e.preventDefault(); e.stopPropagation();
      const abrir = new CustomEvent('leila:investigar-riscos', { cancelable:true, detail:{ id:imovelId } });
      window.dispatchEvent(abrir);
      if (!abrir.defaultPrevented) navigate(rotaAnalise(location.pathname, imovelId), { state:{ investigarRiscos:true } });
    }}>Leilancer Analyser</button>;
}
